import { useState, useEffect, useRef } from "react";
import { colors } from "../../styles/theme";
import { useTenant } from "../../contexts/TenantContext";

export default function TableOfContents({ sections, scrollContainer }) {
  const [activeId, setActiveId] = useState(sections[0]?.id || "");
  const observerRef = useRef(null);
  const tenant = useTenant();
  const accentColor = tenant.theme?.sidebar?.bg || colors.sidebar;

  useEffect(() => {
    if (observerRef.current) observerRef.current.disconnect();

    const root = scrollContainer?.current || null;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const id = entry.target.id.replace("section-", "");
            setActiveId(id);
          }
        }
      },
      { root, rootMargin: "-20% 0px -70% 0px", threshold: 0 }
    );

    for (const section of sections) {
      const el = document.getElementById(`section-${section.id}`);
      if (el) observerRef.current.observe(el);
    }

    return () => observerRef.current?.disconnect();
  }, [sections, scrollContainer]);

  const handleClick = (id) => {
    const el = document.getElementById(`section-${id}`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav style={{ position: "sticky", top: 20 }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 1,
          color: "#999",
          marginBottom: 12,
        }}
      >
        Contents
      </div>
      {sections.map((section) => {
        const isActive = activeId === section.id;
        return (
          <button
            key={section.id}
            onClick={() => handleClick(section.id)}
            style={{
              display: "block",
              width: "100%",
              textAlign: "left",
              padding: "6px 12px",
              marginBottom: 2,
              fontSize: 13,
              lineHeight: 1.4,
              color: isActive ? accentColor : "#666",
              fontWeight: isActive ? 600 : 400,
              background: isActive ? accentColor + "0d" : "transparent",
              border: "none",
              borderLeft: `3px solid ${isActive ? accentColor : "transparent"}`,
              borderRadius: "0 4px 4px 0",
              cursor: "pointer",
              transition: "all 0.15s",
            }}
          >
            {section.title}
          </button>
        );
      })}
    </nav>
  );
}
